var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.actions.length === 1 && _vm.showOneAction
    ? _c(
        "el-button",
        {
          staticClass: "sedap-actions-menu",
          attrs: { type: "text", title: _vm.actions[0].label },
          on: {
            click: function($event) {
              return _vm.handleAction(_vm.actions[0].key)
            }
          }
        },
        [
          _c("i", {
            class:
              (_vm.actions[0].iconPrefix || "fa") + " fa-" + _vm.actions[0].icon
          })
        ]
      )
    : _c(
        "el-dropdown",
        { attrs: { trigger: "click" }, on: { command: _vm.handleAction } },
        [
          _c(
            "el-button",
            { staticClass: "sedap-actions-menu", attrs: { type: "text" } },
            [
              _c("font-awesome-icon", {
                staticClass: "sedap-actions-menu__icon",
                attrs: { icon: "ellipsis-v" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dropdown-menu",
            { attrs: { slot: "dropdown" }, slot: "dropdown" },
            _vm._l(_vm.actions, function(action) {
              return _c(
                "el-dropdown-item",
                {
                  key: action.key,
                  staticClass: "sedap-actions-menu__option",
                  attrs: { command: action.key }
                },
                [
                  _c("i", {
                    class: (action.iconPrefix || "fa") + " fa-" + action.icon
                  }),
                  _vm._v("\n      " + _vm._s(action.label) + "\n    ")
                ]
              )
            }),
            1
          )
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-96114b86", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96114b86","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Tables/ActionsMenu/ActionsMenu.vue
// module id = null
// module chunks = 